/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyUserNotificationsData } from './CompanyUserNotificationsData';
import {
    CompanyUserNotificationsDataFromJSON,
    CompanyUserNotificationsDataFromJSONTyped,
    CompanyUserNotificationsDataToJSON,
} from './CompanyUserNotificationsData';

/**
 * 
 * @export
 * @interface GetCompanyUserNotificationsResponse
 */
export interface GetCompanyUserNotificationsResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetCompanyUserNotificationsResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetCompanyUserNotificationsResponse
     */
    message: string;
    /**
     * 
     * @type {CompanyUserNotificationsData}
     * @memberof GetCompanyUserNotificationsResponse
     */
    data: CompanyUserNotificationsData;
}

/**
 * Check if a given object implements the GetCompanyUserNotificationsResponse interface.
 */
export function instanceOfGetCompanyUserNotificationsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCompanyUserNotificationsResponseFromJSON(json: any): GetCompanyUserNotificationsResponse {
    return GetCompanyUserNotificationsResponseFromJSONTyped(json, false);
}

export function GetCompanyUserNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyUserNotificationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': CompanyUserNotificationsDataFromJSON(json['data']),
    };
}

export function GetCompanyUserNotificationsResponseToJSON(value?: GetCompanyUserNotificationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': CompanyUserNotificationsDataToJSON(value.data),
    };
}

